import { useState, useEffect } from 'react';

import {
  Text,
  Avatar,
  HStack,
  VStack,
  Menu,
  MenuList,
  MenuItem,
  MenuButton,
  useColorModeValue,
} from '@chakra-ui/react';

import { useMsal } from '@azure/msal-react';
import { FaUser } from 'react-icons/fa';

import { useDispatch, useSelector } from 'react-redux';
import { userActions } from 'store/modules/user/user-slice';
import { getUserProfile } from 'store/modules/user/user-action';
import { generateAvatar } from 'utils/avatarHelper';
import { ReducerStatus } from 'utils/constants';

function HeaderAccount() {
  const { accounts } = useMsal();

  // Safe access to user account data with proper null/undefined checks
  const userAccount = accounts?.[0];
  const idTokenClaims = userAccount?.idTokenClaims;
  const name = userAccount?.name;
  const roles = idTokenClaims?.roles || [];

  const roleTextColor = useColorModeValue('gray.600', '#d92e48');

  const dispatch = useDispatch();

  const userProfile = useSelector((state) => state.user.userProfile);
  const avatarUpdateStatus = useSelector(
    (state) => state.user.updateUserProfile.status
  );

  useEffect(() => {
    if (userAccount?.username) {
      dispatch(getUserProfile());
    }
  }, [dispatch, userAccount?.username]);

  useEffect(() => {
    if (
      avatarUpdateStatus === ReducerStatus.SUCCEEDED &&
      userAccount?.username
    ) {
      dispatch(getUserProfile());
    }
  }, [dispatch, avatarUpdateStatus, userAccount?.username]);

  useEffect(() => {
    if (
      userProfile.status === ReducerStatus.SUCCEEDED &&
      userProfile.data &&
      (!userProfile.data.characterJson ||
        userProfile.data.characterJson.trim() === '')
    ) {
      dispatch(userActions.setUserProfilePopup({ modal: true }));
    }
  }, [userProfile.status, userProfile.data, dispatch]);

  const [avatarDataUri, setAvatarDataUri] = useState('');

  // Generate avatar when user profile data is available
  useEffect(() => {
    if (userProfile.data && userProfile.data.characterJson) {
      const characterData = JSON.parse(userProfile.data.characterJson);
      const generatedAvatar = generateAvatar(characterData);
      setAvatarDataUri(generatedAvatar);
    }
  }, [userProfile.data]);

  const handleUserProfileButton = () => {
    dispatch(userActions.setUserProfile({ modal: true }));
  };
  return (
    <Menu>
      <MenuButton
        py={2}
        transition="all 0.3s"
        _focus={{ boxShadow: 'none' }}
        _hover={{ bg: 'gray.400' }}
      >
        <HStack>
          {/* Display custom avatar if available, otherwise fall back to default Chakra Avatar */}
          <Avatar
            size="sm"
            src={avatarDataUri}
            name={name.replace(/\s*\([^)]*\)\s*$/, '').trim()}
            colorScheme="teal"
          />
          <VStack
            display={{ base: 'none', lg: 'flex' }}
            alignItems="flex-start"
            spacing="1px"
            ml="2"
          >
            <Text fontSize="xs">{name}</Text>

            {roles.length > 0 && (
              <Text fontSize="xs" color={roleTextColor}>
                {roles != null && roles.length > 0
                  ? `${roles[roles.length - 1]}`
                  : 's'}
              </Text>
            )}
          </VStack>
        </HStack>
      </MenuButton>
      <MenuList
        bg={useColorModeValue('white', 'gray.900')}
        borderColor={useColorModeValue('gray.200', 'gray.700')}
      >
        <MenuItem icon={<FaUser />} onClick={() => handleUserProfileButton()}>
          Profile
        </MenuItem>
      </MenuList>
    </Menu>
  );
}

export default HeaderAccount;
